import React, { useEffect, useState } from 'react';
import './myAssessment.scss';
import { useDispatch } from 'react-redux';
import {
  listInvitedCandidates,
  getCandidateAssessmentSettings,
  updateCandidateAssessmentSettings,
} from '../../Redux/ActionCreators/testLibraryAction';
import { Table } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

export default function InvitedCandidates() {
  const [candidates, setCandidates] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [pageCount, setPageCount] = useState(1);

  // Settings popup state
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [settingsLoading, setSettingsLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [settingsData, setSettingsData] = useState(null);
  const [attemptLimit, setAttemptLimit] = useState('');
  // const [violationLimit, setViolationLimit] = useState('');
  // const [passThreshold, setPassThreshold] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const rows = 10;
  const timerRef = React.useRef(null);

  const testId = location?.state?.testId;
  const ruleSetJson = location?.state?.ruleSetJson || null;

  useEffect(() => {
    if (testId) {
      fetchCandidates('', 1);
    }
  }, [testId]);

  const fetchCandidates = React.useCallback(async (searchText, page) => {
    setIsLoading(true);
    const res = await dispatch(listInvitedCandidates(testId, searchText, page, rows));
    if (res?.payload) {
      setCandidates(res.payload.data || []);
      setTotalCount(res.payload.totalCount || 0);
    }
    setIsLoading(false);
  }, [dispatch, testId]);

  const searchCandidate = (val) => {
    clearTimeout(timerRef.current);
    setSearch(val);
    setPageCount(1);
    timerRef.current = setTimeout(() => fetchCandidates(val, 1), 800);
  };

  const openSettings = async (candidate) => {
    setSelectedCandidate(candidate);
    setSettingsData(null);
    setAttemptLimit('');
    // setViolationLimit('');
    // setPassThreshold('');
    setSettingsOpen(true);
    setSettingsLoading(true);
    const res = await dispatch(getCandidateAssessmentSettings(testId, candidate.userId));
    if (res?.payload) {
      setSettingsData(res.payload);
      setAttemptLimit(res.payload.attemptLimit ?? '');
      // setViolationLimit(res.payload.violationLimit ?? '');
      // setPassThreshold(res.payload.passThreshold ?? '');
    }
    setSettingsLoading(false);
  };

  const closeSettings = () => {
    setSettingsOpen(false);
    setSelectedCandidate(null);
    setSettingsData(null);
    setAttemptLimit('');
  };

  const submitSettings = async () => {
    if (!selectedCandidate) return;
    setSubmitLoading(true);
    const body = {
      ...(settingsData || {}),
      testId: testId,
      userId: selectedCandidate.userId,
      attemptLimit: Number(attemptLimit),
      // violationLimit: Number(violationLimit),
      // passThreshold: Number(passThreshold),
    };
    const res = await dispatch(updateCandidateAssessmentSettings(body));
    if (res.status === 200) {
        await fetchCandidates('', 1)
    }
    setSubmitLoading(false);
    closeSettings();
  };

  const openAttemptReport = (candidate) => {
    navigate('/assessments-report', {
      state: {
        id: testId,
        ruleSetJson: ruleSetJson,
        prefilledEmail: candidate.emailId,
      },
    });
  };

  const paginate = (pageNumber) => {
    const totalPages = Math.ceil(totalCount / rows);
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setPageCount(pageNumber);
    fetchCandidates(search, pageNumber);
  };

  const totalPages = Math.ceil(totalCount / rows);

  const Pagination = ({ currentPage, totalPages, currentDataLength, total, paginate }) => {
    const getPageNumbers = () => {
      if (totalPages <= 4) {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
      } else if (currentPage <= 3) {
        return [1, 2, 3, '...', totalPages];
      } else if (currentPage >= totalPages - 2) {
        return [1, '...', totalPages - 2, totalPages - 1, totalPages];
      } else {
        return [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
      }
    };
    return (
      <div className="pagination">
        <div className="pagination-info">
          {currentDataLength > 0 ? (
            <span>
              Showing <strong>{(currentPage - 1) * rows + 1}</strong>-
              <strong>{(currentPage - 1) * rows + currentDataLength}</strong> of{' '}
              <strong>{total}</strong>
            </span>
          ) : (
            <span>Showing 0-0 of 0</span>
          )}
        </div>
        <div className="pagination-buttons">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            <img src="/images/leftarrow-icon.svg" alt="" />
          </button>
          {getPageNumbers().map((page, index) => (
            <button
              key={index}
              onClick={() => (page === '...' ? null : paginate(page))}
              className={currentPage === page ? 'active' : ''}
              disabled={page === '...'}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages || totalPages === 0}
          >
            <img
              src="/images/leftarrow-icon.svg"
              alt=""
              style={{ transform: 'rotate(180deg)' }}
            />
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="gappeo-my-tests">
      <div style={{ padding: '24px 12px' }}>
        <h1
          className="d-flex justify-content-left flex-wrap"
          style={{fontFamily: `"Manrope", sans-serif`,}}
        >
          <img
            src="/images/back.svg"
            alt=""
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />&nbsp;&nbsp;Invited Candidates
        </h1>
      </div>

      <div className="table-admin mt-3">
        <div className="search-test mt-3 d-flex align-items-center">
          <div className="has-search" style={{ width: '70%' }}>
            <span className="form-control-feedback">
              <img src="/images/search.svg" alt="" width={12} />
            </span>
            <input
              type="text"
              className="form-control"
              value={search}
              placeholder="Search candidate by Name or Email Address"
              onChange={(e) => searchCandidate(e.target.value)}
            />
          </div>
        </div>

        <Table responsive className="assessment-table">
          <thead>
            <tr>
              <th>NAME</th>
              <th>EMAIL</th>
              <th className='text-center'>ATTEMPT COUNT</th>
              <th className='text-right'>ACTION</th>
            </tr>
          </thead>
          <tbody className="table-body">
            {isLoading ? (
              <tr>
                <td colSpan="4">
                  <div className="loading-overlay" style={{ alignItems: 'start', color: '#F75891', height: 'auto' }}>
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </td>
              </tr>
            ) : candidates?.length > 0 ? (
              candidates.map((candidate) => (
                <tr key={candidate.userId}>
                  <td>
                    <strong>{candidate.name}</strong>
                  </td>
                  <td>{candidate.emailId}</td>
                  <td className='text-center'>
                    <span
                      style={{
                        cursor: (candidate.totalAttempts ?? 0) === 0 ? 'default' : 'pointer',
                        color: (candidate.totalAttempts ?? 0) === 0 ? '#6b7280' : '#F75891',
                        textDecoration: (candidate.totalAttempts ?? 0) === 0 ? 'none' : 'underline',
                      }}
                      onClick={(candidate.totalAttempts ?? 0) === 0 ? undefined : () => openAttemptReport(candidate)}
                    >
                      {candidate.totalAttempts ?? 0}
                    </span>
                  </td>
                  <td className='text-right'>
                    <img
                      src="/images/settings-icon.svg"
                      alt="settings"
                      className="cursor-pointer"
                      style={{ width: 20, height: 20 , marginRight:'20px'}}
                      onClick={() => openSettings(candidate)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">
                  <div className="empty-list">
                    <img src="/images/magnifier.svg" alt="" />
                    <div className="mt-2">
                      <h3>No invited candidates found</h3>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        {!isLoading && candidates?.length > 0 && (
          <Pagination
            currentPage={pageCount}
            totalPages={totalPages}
            currentDataLength={candidates.length}
            total={totalCount}
            paginate={paginate}
          />
        )}
      </div>

      {/* Settings Popup */}
      {settingsOpen && (
        <div className="upload-modal">
          <div className="modal-content" style={{ width: '435px' }}>
            <div className="modal-head">
              <div></div>
              <h3>Candidate Settings</h3>
              <img
                src="/images/close-icon.svg"
                alt=""
                className="cursor-pointer"
                onClick={closeSettings}
              />
            </div>

            {settingsLoading ? (
              <div
                className="modal-body-text d-flex justify-content-center align-items-center"
                style={{ padding: '30px 15px' , overflow: 'unset'}}
              >
                <div
                  className="loading-overlay"
                  style={{ alignItems: 'start', color: '#F75891', height: 'auto' }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="modal-body-text" style={{alignItems:'unset', overflow: 'unset'}}>
                  <div className='modal-input-label'>
                    <label>
                      Attempt Limit *
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={attemptLimit}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === '' || val === '-') { setAttemptLimit(''); return; }
                        setAttemptLimit(Math.max(0, Number(val)));
                      }}
                      min={0}
                    />
                  </div>

                  {/* <div className='modal-input-label'>
                    <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, fontSize: 14 }}>
                      Violation Limit
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={violationLimit}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === '' || val === '-') { setViolationLimit(''); return; }
                        setViolationLimit(Math.max(0, Number(val)));
                      }}
                      min={0}
                    />
                  </div> */}

                  {/* <div className='modal-input-label'>
                    <label style={{ display: 'block', marginBottom: 4, fontWeight: 500, fontSize: 14 }}>
                      Pass Threshold
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      value={passThreshold}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === '' || val === '-') { setPassThreshold(''); return; }
                        setPassThreshold(Math.max(0, Number(val)));
                      }}
                      min={0}
                    />
                  </div> */}
                </div>

                <div className="d-flex justify-content-center" style={{ paddingBottom: 15 }}>
                  <button
                    className="upload-btn"
                    onClick={submitSettings}
                    disabled={submitLoading}
                  >
                    {submitLoading ? 'Saving...' : 'Submit'}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
